import { sanitizeFirstname, sanitizeLastname } from '@distribution/composants-business-design';

export function formatPrenom(prenom: string): string {
  return sanitizeFirstname(prenom);
}

export function formatNom(nom: string): string {
  return sanitizeLastname(nom);
}

export function formatNomComplet(
  prenom: string | undefined | null,
  nom: string | undefined | null,
  isNomFirst = false,
): string | undefined {
  const parts: string[] = [];

  if (prenom) {
    parts.push(formatPrenom(prenom));
  }

  if (nom) {
    if (isNomFirst) {
      parts.unshift(formatNom(nom));
    } else {
      parts.push(formatNom(nom));
    }
  }

  return parts.join(' ') || undefined;
}
